import Swiper from "swiper";

function initSlider() {
    new Swiper(".js-info-labels-slider", {
        slidesPerView: 1,
        centerSlidesBounds: true,
        spaceBetween: 4,
        watchOverflow: true,

        breakpoints: {
            // slidesPerView: auto некорректно отображает слайды - появляется смещение и отступ справа
            // поэтому сделал по брейкпоинтам
            345: {
                slidesPerView: 1.2,
            },
            420: {
                slidesPerView: 1.3,
            },
            460: {
                slidesPerView: 1.5,
            },
            500: {
                slidesPerView: 1.8,
            },
            540: {
                slidesPerView: 2,
            },
            600: {
                slidesPerView: 2.3,
            },
        },
    });
}
function initSliderVertical() {
    new Swiper(".js-info-labels-slider-vertical", {
        slidesPerView: 0.6,
        centerSlidesBounds: true,
        spaceBetween: 4,

        watchOverflow: true,

        breakpoints: {
            // slidesPerView: auto некорректно отображает слайды - появляется смещение и отступ справа
            // поэтому сделал по брейкпоинтам

            420: {
                slidesPerView: 1,
            },
            460: {
                slidesPerView: 1.5,
            },
            500: {
                slidesPerView: 1.6,
            },
            540: {
                slidesPerView: "auto",
            },
        },
    });
}

window.addEventListener("load", () => {
    if (window.mobileMedia) {
        initSlider();
        initSliderVertical();
    }
});
